import React from "react";
import { FaMousePointer, FaEdit, FaShare } from "react-icons/fa";

const steps = [
  {
    number: 1,
    title: "Pick a Template",
    description: "Choose from our library of professional templates designed specifically for cricket clubs.",
    icon: FaMousePointer,
  },
  {
    number: 2,
    title: "Fill in Match Details",
    description: "Data automatically syncs from Play-Cricket, or customize manually to create your perfect post.",
    icon: FaEdit,
  },
  {
    number: 3,
    title: "Share Instantly",
    description: "Generate your graphic and share directly to social media or download for later use.",
    icon: FaShare,
  },
];

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-white via-purple-50 to-snaptrix-blue-50" aria-labelledby="how-it-works-heading">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2
            id="how-it-works-heading"
            className="text-3xl md:text-4xl lg:text-5xl font-bold text-snaptrix-gray-700 mb-4"
          >
            How It Works
          </h2>
          <p className="text-lg md:text-xl text-snaptrix-gray-600 max-w-2xl mx-auto">
            Three simple steps to transform your cricket club's social media presence
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                className="relative text-center p-6 md:p-8 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                {/* Connecting Line (hidden on mobile) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-6 w-12 h-1 bg-gradient-to-r from-snaptrix-blue-400 to-purple-400 transform -translate-y-1/2 rounded-full shadow-sm" />
                )}
                
                {/* Step Number */}
                <div className="inline-flex items-center justify-center w-16 h-16 bg-snaptrix-blue-600 text-white rounded-full text-2xl font-bold mb-4">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="mb-4 flex justify-center">
                  <div className="p-4 bg-snaptrix-blue-50 rounded-full">
                    <Icon className="text-snaptrix-blue-600 text-3xl md:text-4xl" aria-hidden="true" />
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl md:text-2xl font-bold mb-3 text-snaptrix-gray-700">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-snaptrix-gray-600 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
